<script lang="ts" setup>
import { onMounted } from 'vue'
import useOverlay from '@/legacy/ts/useOverlay'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		default: '',
	},
	autoClose: {
		type: Boolean,
		default: true,
	},
	lockScroll: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['update:modelValue'])
function updateModelValue(value: boolean) {
	emit('update:modelValue', value)
}
function onOverlayClick() {
	if (props.autoClose) {
		isShow.value = false
	}
}

const { isShow, freezeBodyScroll } = useOverlay(props, updateModelValue)
onMounted(() => {
	if (props.lockScroll) {
		freezeBodyScroll()
	}
})
</script>

<template>
	<div class="bs-drawer-panel" v-if="isShow">
		<div class="bs-drawer-panel__overlay" @click.capture="onOverlayClick"></div>
		<transition name="bs-drawer-panel__animation">
			<div class="bs-drawer-panel__panel">
				<div class="bs-drawer-panel__panel__header">
					<div class="bs-drawer-panel__panel__header__deco"></div>
					<span class="bs-drawer-panel__panel__header__title">
						{{ title }}
					</span>
					<div class="bs-drawer-panel__panel__header__trailing">
						<slot name="title-trailing" />
					</div>
				</div>
				<div class="bs-drawer-panel__panel__main">
					<slot />
				</div>
			</div>
		</transition>
	</div>
</template>
